import { BrowserRouter, Route, Routes } from "react-router-dom";
import Validate from "./screens/validate/Validate";
import { ViewDetails } from "./screens/view/ViewDetails";

export const Main: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Validate />} />
        <Route path="view" element={<ViewDetails />} />
      </Routes>
    </BrowserRouter>
  );
};
